module.exports = __webpack_public_path__ + "img/tema-1-8.f945c0b9.svg";